/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef } from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import {
  Col, Row, Card,
  Modal, Button,
} from 'antd';

import InfoView from 'components/common/InfoView';
import AboutItem from 'components/common/AboutItem';
import PropTypes from 'prop-types';
import PasswordResetForm from './PasswordResetForm';
import NameUpdateForm from './NameUpdateForm';
import {
  updatePassword,
  updateUserInfo,
} from '../../redux/actions/Auth';
import { history } from '../../redux/store';

const ProfileDetails = ({ selectedUser }) => {
  const dispatch = useDispatch();
  const user = useSelector(({ auth }) => auth.authUser);
  const loading = useSelector(({ common }) => common.loading);
  const [visible, setVisible] = useState(false);
  const [isNameModel, setIsNameModel] = useState(false);
  const passwordForm = useRef();
  const nameForm = useRef();

  const profileItems = [
    {
      id: 1,
      title: 'Email',
      icon: 'email',
      desc: selectedUser?.email || user.email,
    },
    {
      id: 2,
      title: 'Gender',
      icon: 'user',
      desc: selectedUser?.gender || user.gender,
    },
  ];

  const handleCancel = () => {
    setVisible(false);
    setIsNameModel(false);
  };

  const handleOk = () => {
    if (passwordForm.current && !isNameModel) {
      passwordForm.current.validateFields().then(({ password, passwordAgain }) => {
        if (passwordAgain === password) {
          const data = { password };
          dispatch(updatePassword(selectedUser?._id || user._id, data, selectedUser));
          if (selectedUser === null) {
            history.push('/signin');
          }
          setTimeout(() => {
            setVisible(false);
          }, 2000);
        }
      }).catch((error) => {
        console.error(error.errorFields);
      });
    }
    if (nameForm.current && isNameModel) {
      nameForm.current.validateFields().then((values) => {
        dispatch(updateUserInfo(selectedUser?._id || user._id, values));
        setTimeout(() => {
          setIsNameModel(false);
          setVisible(false);
        }, 2000);
      }).catch((error) => {
        console.error(error.errorFields);
      });
    }
  };

  const handleShowResetModal = () => {
    if (passwordForm.current) {
      passwordForm.current.resetFields();
    }
    setVisible(true);
    setIsNameModel(false);
  };

  const handleShowNameModal = () => {
    if (nameForm.current) {
      nameForm.current.resetFields();
    }
    setVisible(true);
    setIsNameModel(true);
  };

  return (
    (
      <div>
        <Card
          title={selectedUser?.full_name || user.full_name}
          extra={(
            <div className="password-reset-button">
              {selectedUser?.role?.name !== 'Admin' && (
                <>
                  <Button
                    type="primary"
                    onClick={() => handleShowResetModal()}
                  >
                    Reset Password
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => handleShowNameModal()}
                  >
                    Update Name
                  </Button>
                </>
              )}
            </div>
          )}
          className="gx-card-tabs gx-card-profile"
        >
          <Row>
            {profileItems.map((about) => (
              <Col key={about.id} xl={8} lg={12} md={12} sm={12} xs={24}>
                <AboutItem data={about} />
              </Col>
            ))}
          </Row>
          <Modal
            title={isNameModel ? 'Update Name' : 'Reset Password'}
            open={visible}
            okText="Save"
            onOk={handleOk}
            confirmLoading={loading}
            onCancel={handleCancel}
          >
            {isNameModel
              ? (
                <NameUpdateForm {...{
                  ref: nameForm,
                }}
                />
              )
              : (
                <PasswordResetForm {...{
                  ref: passwordForm,
                }}
                />
              )}
          </Modal>
        </Card>
        <InfoView />
      </div>
    )
  );
};

ProfileDetails.propTypes = {
  selectedUser: PropTypes.shape({
    _id: PropTypes.string,
    email: PropTypes.string,
    full_name: PropTypes.string,
    gender: PropTypes.string,
    role: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
};
ProfileDetails.defaultProps = {
  selectedUser: null,
};

export default ProfileDetails;
